import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft, Scale } from "lucide-react";
import { CGUPartA } from "../components/cgu/CGUPartA";
import { CGUPartB } from "../components/cgu/CGUPartB";
import { CGUPartC } from "../components/cgu/CGUPartC";

export default function CGUPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="text-slate-600 hover:text-slate-900" data-testid="cgu-back-btn">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="flex items-center gap-2">
            <Scale className="w-6 h-6 text-[#16233B]" />
            <h1 className="text-lg font-bold text-[#16233B]">Conditions Generales d'Utilisation</h1>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 md:p-8 space-y-8" data-testid="cgu-content">
          <div className="text-center border-b border-slate-200 pb-6">
            <h1 className="text-2xl font-bold text-[#16233B] mb-2">CONDITIONS GENERALES D'UTILISATION - ODYS'IA</h1>
            <p className="text-slate-600 text-sm">Plateforme d'Intelligence Artificielle d'Aide a la Decision en Investissement Immobilier</p>
            <p className="text-slate-500 text-sm mt-2">Editeur : RIADH'IMMO</p>
            <p className="text-slate-500 text-xs mt-1">Version 2.1 - Conforme 2026</p>
            <p className="text-slate-400 text-xs">Date d'entree en vigueur : 17 fevrier 2026 | Derniere mise a jour : 12 mai 2026</p>
          </div>

          <CGUPartA />
          <CGUPartB />
          <CGUPartC />
        </div>
      </main>

      <footer className="max-w-4xl mx-auto px-4 py-6 text-center text-xs text-slate-400">
        <p>Odys'IA - RIADH'IMMO - Version 2.1 - 12 mai 2026</p>
        <p>Document conforme au RGPD (UE 2016/679) et a l'AI Act (UE 2024/1689)</p>
      </footer>
    </div>
  );
}
